/* eslint-disable prettier/prettier */
import { bugsnag } from 'shared/utils/services/bugsnag';

// NOTE: remove any non alphanumeric values from SKU
const sanitizeSKU = (sku = '') => sku?.replace(/[^\da-z]/gi, '');

/**
 * NOTE: Snapchat seems very particular about the format of their params. Without
 * the keys being in string format trackers do not fire correctly
 */
export const fireSnapchatTracker = (type: string, params = {}, retry = 5) => {
  // NOTE: Do not fire if one trust advertising category is blocked or SSR
  if (!window?.OptanonActiveGroups?.includes('C0004') || typeof window === 'undefined') return;

  /**
   * NOTE: Sometimes snapchat is not initialized in time for the tracker, therefore
   * retry a max of 5 times
   */
  if (!window?.snaptr && retry > 0) {
    setTimeout(() => {
      fireSnapchatTracker(type, params, retry - 1);
    }, 1000 * 2 ** (5 - retry));

    return;
  }

  try {
    window?.snaptr('track', type, params);
  } catch (error) {
    /**
     * NOTE: notify bugsnag of all errors except for when snaptr is undefined after
     * 5 retries. The cause of snaptr can be for a number of reasons and tends to
     * happen only on production but even then cannot reproduce.
     */
    if (retry > 0) {
      const errorMessage = (error as Error)?.message;

      bugsnag(`Error firing snapchat tracker: ${errorMessage}. retry count: ${retry}.`, {
        context: 'tracking',
        severity: 'warning',
      });
    }
  }
};

export const fireSnapchatAddCart = ({ brandName, productPrice, sku, clientDedupID }) => {
  fireSnapchatTracker('ADD_CART', {
    item_category: brandName,
    item_ids: [sanitizeSKU(sku)],
    price: productPrice * 0.01,
    client_dedup_id: clientDedupID,
  });
};

export const fireSnapchatCheckoutPurchase = ({ brandName, orderNumber, price, sku }) => {
  fireSnapchatTracker('PURCHASE', {
    item_category: brandName,
    item_ids: [sanitizeSKU(sku)],
    price: price * 0.01,
    transaction_id: orderNumber,
  });
};

export const fireSnapchatPageView = (clientDedupID) => {
  fireSnapchatTracker('PAGE_VIEW', { client_dedup_id: clientDedupID });
};

export const fireSnapchatPDPView = ({ brandName, lowestPriceCents, sku, clientDedupID }) => {
  fireSnapchatTracker('PAGE_VIEW', {
    price: lowestPriceCents && lowestPriceCents * 0.01,
    item_ids: sku && [sanitizeSKU(sku)],
    item_category: brandName,
    client_dedup_id: clientDedupID,
  });
};

export const fireSnapchatSignUp = (clientDedupID) => {
  fireSnapchatTracker('SIGN_UP', { client_dedup_id: clientDedupID });
};
/* eslint-enable prettier/prettier */
